'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkSecureToken = linkSecureToken;
exports.userDeviceLogin = userDeviceLogin;
exports.isPreauthorize = isPreauthorize;

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

var _Guid = require('./Guid');

var _Guid2 = _interopRequireDefault(_Guid);

var _Cookie = require('../server/Cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function linkSecureToken(req, res, sessionId, lang, deviceId, productName, platform, features, handleUserInfoRedirection, errorRedirect, loginClient, callback) {
  var correlationId = (0, _Guid2.default)();
  var promise = loginClient.subscription.linkSecureToken({
    sessionId: sessionId,
    token: req.query.token,
    operatorId: req.query.operator_id,
    languageTag: lang,
    clientId: req.query.client_id,
    deviceId: deviceId
  }, { responseContentType: 'application/json', 'correlation-id': correlationId });

  promise.then(function (result) {
    handleUserInfoRedirection(req, res, result.obj, sessionId, productName, platform, features, loginClient, callback);
  });
  promise.catch(function (error) {
    errorRedirect(req, res, error, correlationId, sessionId);
  });
}

function userDeviceLogin(req, res, realm, lang, deviceId, productName, platform, features, handleUserInfoRedirection, errorRedirect, loginClient, callback) {
  var correlationId = (0, _Guid2.default)();
  var promise = loginClient.user.userDeviceLogin({
    clientId: req.query.client_id,
    languageTag: lang,
    deviceId: deviceId
  }, { responseContentType: 'application/json', 'correlation-id': correlationId });

  promise.then(function (result) {
    _Cookie.Cookie.saveSessionId(req, res, result.obj.sessionId, realm, _config2.default.isSecured);
    linkSecureToken(req, res, result.obj.sessionId, lang, deviceId, productName, platform, features, handleUserInfoRedirection, errorRedirect, loginClient, callback);
  });
  promise.catch(function (error) {
    errorRedirect(req, res, error, correlationId);
  });
}

function isPreauthorize(query) {
  return query.token && query.operator_id;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Preauthorize.js
// module id = 413
// module chunks = 0